const LINK_PROTOCOLS = ['http:', 'https:', 'mailto:'];
const IMAGE_PROTOCOLS = ['http:', 'https:'];

// Whether a URL from untrusted Markdown (e.g. model output) may become an
// `href` or `src`. Only absolute http(s) URLs (and mailto: for links) pass, so
// `javascript:`, `data:` and the like can't reach the DOM.
export const isSafeMarkdownUrl = (url: string, kind: 'link' | 'image' = 'link') => {
	try {
		const { protocol } = new URL(url.trim());
		return (kind === 'image' ? IMAGE_PROTOCOLS : LINK_PROTOCOLS).includes(protocol);
	} catch {
		return false;
	}
};
